import { jwtDecode } from "jwt-decode";

export const expiresAfterMilliseconds = (jwt: string) => {
    const payload = jwtDecode(jwt) as any;
    return (payload.exp - payload.iat) * 1000;
};

export const expiresAt = (() => {
    const cache = new Map<string, Date>();

    return (jwt: string) => {
        if (cache.has(jwt)) {
            return cache.get(jwt)!;
        }
        const payload = jwtDecode(jwt) as any;
        const expiryDate = new Date(payload.exp * 1000);
        cache.set(jwt, expiryDate);
        return expiryDate;
    };
})();

const checkIsExpired = (token: string, offsetMs: number) => {
    try {
        const expiry = expiresAt(token || "");
        return expiry.valueOf() - offsetMs < new Date().valueOf();
    } catch {
        return true;
    }
};

export const validToken = (token: string | undefined) => {
    // Adds a buffer of 5 minutes
    const fiveMinutesInMilliseconds = 5 * 60 * 1000;
    if (token && !checkIsExpired(token, fiveMinutesInMilliseconds)) {
        return token;
    }
};

export const getIssuer = (token: string | undefined) => {
    if (!token) {
        return false;
    }

    const decodedToken = jwtDecode(token) as {
        iss?: string;
        [key: string]: any;
    };
    const issuer = decodedToken?.iss;
    return issuer;
};

export const getDecodedJwt = (token: string) => {
    if (!token) {
        return {};
    }
    const decodedToken = jwtDecode(token) as {
        iss?: string;
        aud?: string;
        exchanged?: {
            account_id: string;
            scopes: string[];
        };
    };
    return decodedToken;
};
